import { useAppSelector } from 'store/hooks';
import { selectIsSystemSession } from 'features/application/selectors';

export const useSystemSession = () => useAppSelector(selectIsSystemSession);
